window.OneSignal = window.OneSignal || [];
window.OneSignal.push(() => {
  window.OneSignal.init({
    appId: window.config.VUE_APP_ONESIGNAL,
    allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== "production",
    safari_web_id: window.config.VUE_APP_ONESIGNAL_SAFARI_WEB_ID,
    notifyButton: {
      enable: false
    }
  });
});
